module.exports = __webpack_public_path__ + "img/20200621_095319.517855ad.jpg";